/* eslint-disable no-underscore-dangle */
import { OrderEntity } from '@/entities';
import { Action } from '@/shared/types/action';
import { Action3dsOrder } from '@/shared/actions/order-3ds';
import { Action3dsV2Order } from '@/shared/actions/order-3ds-v2';
import { FetchOrderSuccessAction } from '@/shared/actions/fetch';
import { PayerInfoChangedAction } from '@/shared/actions/payer-info';
import * as A from '@/shared/constants/action-types';


export type OrderState = {
    order: OrderEntity.Order
    _3dsOrder: OrderEntity.Order3ds
    _3dsV2Order: OrderEntity.Order3dsV2
    loading: boolean
    completed: boolean
    redemptionSmsPopupOpen: boolean
    redemptionCodeTtl: number
}

const initialState: OrderState = {
    order      : {
        id          : -1,
        description : '',
        customerInfo: {
            name : '',
            email: '',
            phone: '',
        },
        products    : [],
        total       : {
            amount  : 0,
            currency: 0,
            displayCurrency: '',
        },
    },
    _3dsOrder  : {
        billingOrder: {
            id                  : -1,
            paymentTransactionId: '',
            _3ds                : {
                ascUrl   : '',
                md       : '',
                paReq    : '',
                creq     : '',
                returnUrl: '',
            },
        },
        status      : '',
    },
    _3dsV2Order: {},
    loading    : false,
    completed  : false,
    redemptionSmsPopupOpen: false,
    redemptionCodeTtl: 0,
};


export const order = (state = initialState, action: Action) => {
    switch (action.type) {
        case A.FETCH_START: {
            return { ...state, loading: true };
        }
        case A.FETCH_FINISH: {
            return { ...state, loading: false };
        }
        case A.FETCH_ORDER_SUCCESS: {
            const { payload: { order } } = action as FetchOrderSuccessAction;
            return { ...state, order };
        }
        case A.PAYER_INFO_CHANGED: {
            const { payload: { value, name } } = action as PayerInfoChangedAction;
            const newState = { ...state };
            newState.order.customerInfo[name] = value;
            return newState;
        }
        case A._3DS_ORDER: {
            const { payload: billingOrder } = action as Action3dsOrder;
            return { ...state, _3dsOrder: { billingOrder } };
        }
        case A._3DSV2_ORDER_CLEAR: {
            return { ...state, _3dsV2Order: {} };
        }
        case A._3DSV2_ORDER: {
            const { payload: billingOrder } = action as Action3dsV2Order;
            return { ...state, _3dsV2Order: { billingOrder } };
        }
        case A.ORDER_COMPLETED: {
            return { ...state, completed: true };
        }
        case A.OPEN_REDEMPTION_SMS_POPUP: {
            const { open, ttl } = action.payload;

            return {
                ...state,
                redemptionSmsPopupOpen: open,
                redemptionCodeTtl: ttl || state.redemptionCodeTtl,
            };
        }
        default: return state;
    }
};
